import { render } from "./inactive-blog.vue?vue&type=template&id=0605553a"
import script from "./inactive-blog.vue?vue&type=script&lang=js"
export * from "./inactive-blog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__